/* Mount Leaf — premium motion layer.
   Scroll-lit statements, pinned product showcase, count-up stats, glass header, spotlight.
   Everything is skipped for visitors who prefer reduced motion. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wide = window.matchMedia('(min-width: 901px)');
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const ease = t => 1 - Math.pow(1 - t, 3);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const scenes = [];
  const tick = () => scenes.forEach(fn => fn());
  let queued = false;
  const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; tick(); }); } };

  /* Words brighten as the statement passes through the middle of the screen */
  function scrubWords() {
    $$('[data-scrub-words]').forEach(el => {
      const words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(w => `<span class="sw">${w}</span>`).join(' ');
      const spans = $$('.sw', el);
      if (reduce) { spans.forEach(s => s.classList.add('is-lit')); return; }
      let last = -1;
      scenes.push(() => {
        const r = el.getBoundingClientRect();
        const p = clamp((innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.35));
        const n = Math.round(p * spans.length);
        if (n === last) return;
        last = n;
        spans.forEach((s, i) => s.classList.toggle('is-lit', i < n));
      });
    });
  }

  /* Showcase now renders as a fluid, high-converting product section without scroll-jacking */
  function showcase() {}

  /* Ingredient close-ups: the photo opens from a rounded window to full bleed as it enters */
  function macros() {
    $$('[data-macro]').forEach(sec => {
      const frame = sec.querySelector('.macro-frame');
      if (reduce) return;
      scenes.push(() => {
        const r = sec.getBoundingClientRect();
        const enter = clamp((innerHeight - r.top) / (innerHeight * 0.9));   // 0 when the top touches the bottom of the screen
        const k = ease(enter);
        const insetY = (1 - k) * Math.min(innerHeight * 0.1, 80);
        const insetX = (1 - k) * Math.min(innerWidth * 0.08, 120);
        frame.style.setProperty('--mi', insetY + 'px');
        frame.style.setProperty('--mx2', insetX + 'px');
        frame.style.setProperty('--mr', (1 - k) * 36 + 'px');
        frame.style.setProperty('--ms', 1.18 - 0.18 * k);
        const t = ease(clamp((enter - 0.45) / 0.45));
        frame.style.setProperty('--mo', t);
        frame.style.setProperty('--my2', (1 - t) * 40 + 'px');
      });
    });
  }

  /* Numbers count up once when they come into view */
  function counters() {
    const els = $$('[data-count-to]');
    if (!els.length) return;
    const run = el => {
      const to = parseFloat(el.dataset.countTo);
      if (isNaN(to)) return;
      const dec = Number(el.dataset.decimals) || 0;
      const from = to > 1900 && to < 2100 ? to - 25 : 0;
      const isYear = to > 1900 && to < 2100;
      const fmt = v => dec ? v.toFixed(dec) : (isYear ? String(Math.round(v)) : Math.round(v).toLocaleString('en-IN'));
      if (reduce) { el.textContent = fmt(to); return; }
      const t0 = performance.now(), dur = 1600;
      const step = now => {
        const k = ease(clamp((now - t0) / dur));
        el.textContent = fmt(from + (to - from) * k);
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver(en => en.forEach(e => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: 0.6 });
    els.forEach(el => { el.textContent = el.dataset.countTo > 1900 && el.dataset.countTo < 2100 ? el.dataset.countTo - 25 : '0'; io.observe(el); });
  }

  /* Header turns to frosted glass once the page scrolls */
  function glassHeader() {
    const h = document.getElementById('siteHeader');
    if (!h) return;
    scenes.push(() => h.classList.toggle('is-glass', scrollY > 8));
  }

  /* Soft light follows the pointer on dark panels and cards */
  function spotlight() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    $$('.bg-forest, .tc, .kit, .rt-total').forEach(el => {
      if (el.classList.contains('has-spot')) return;
      el.classList.add('has-spot');
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--mx', `${e.clientX - r.left}px`);
        el.style.setProperty('--my', `${e.clientY - r.top}px`);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.add('ml-premium');
    // The mobile menu lives in the header section; move it to <body> so the sticky header doesn't trap it under the backdrop
    const mnav = document.getElementById('mnav');
    if (mnav && mnav.parentElement !== document.body) document.body.appendChild(mnav);
    scrubWords(); showcase(); macros(); counters(); glassHeader(); spotlight();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    tick();
    // Kit cards and other content render after this script; re-run spotlight once
    setTimeout(spotlight, 800);
  });
})();
